var exports = {
  "$": "hpcContainer__YC55Dd",
};

module.exports = exports;
